export enum AnimationType {
  scaleInOut = 'scaleInOut',
}

export interface AnimatedContainerProps {
  animation?: AnimationType
}
